import { HTMLAttributes, TextareaHTMLAttributes } from 'react';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  labelColor?: string;
  error?: string;
  divProps?: HTMLAttributes<HTMLDivElement>;
  isCompany?: boolean;
  onlyInput?: boolean;
}

export enum InputLabelColor {
  Light = 'Light',
  Dark = 'Dark',
}
